import {
  EventRegistrationFormFragment,
  EventRegistrationForm_ViewerFragment,
} from './__generated__/Event.graphql';
import EventCardLocationInfo from './EventCardLocationInfo';
import EventCardTimeInfo from './EventCardTimeInfo';
import EventTitleWithModifier from './EventTitleWIthModifier';
import RegistrationForm from './RegistrationForm';
import {EventExtraDataProps} from './RegistrationForm.Registered';
import useEventState from './useEventState';
import {GroupSessionRequestStatus} from '../../../__generated__/graphql/types';
import useAppTheme from '../design_system/hooks/useAppTheme';
import useScrollToRefOnLocationHash from '../design_system/hooks/useScrollToRefOnLocationHash';
import Typography, {Size} from '../design_system/typography/Typography';

import {css} from '@emotion/react';
import React from 'react';

export interface Props {
  readonly event: EventRegistrationFormFragment;
  readonly eventExtraData: EventExtraDataProps;
  readonly formHash: string;
  readonly isRegistered: boolean;
  readonly viewer: Maybe<EventRegistrationForm_ViewerFragment>;
  readonly registeredStatus?: GroupSessionRequestStatus;
}

export default function RegistrationFormCard(props: Props): JSX.Element {
  const {
    event,
    eventExtraData,
    formHash,
    isRegistered,
    registeredStatus,
    viewer,
  } = props;
  const formRef = useScrollToRefOnLocationHash<HTMLDivElement>(formHash);
  const theme = useAppTheme();
  const {eventState} = useEventState(
    event.startTimeUTCSeconds ?? 0,
    event.durationSeconds ?? 0,
  );

  return (
    <div
      css={css({
        boxShadow: '0 3px 9px 0 rgba(0, 0, 0, 0.16)',
        flex: 0,
        flexBasis: '404px',
        padding: '36px 28px 36px 28px',
      })}
      ref={formRef}
    >
      <Typography
        size={Size.M}
        variant="h2"
      >
        <EventTitleWithModifier groupSession={event} />
      </Typography>

      <div
        css={css({
          borderBottom: `2px solid ${theme.palettes.background.neutral.disabled}`,
          display: 'grid',
          gap: '1rem',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          marginBottom: theme.spacing.x28,
          marginTop: theme.spacing.x12,
          paddingBottom: theme.spacing.x28,
        })}
      >
        <EventCardTimeInfo data={event} />
        <EventCardLocationInfo data={event.venue} />
      </div>

      <RegistrationForm
        event={event}
        eventData={eventExtraData}
        eventState={eventState}
        isDisabled={eventState === 'completed'}
        isRegistered={isRegistered}
        onlineInfo={event.onlineInfo}
        registeredStatus={registeredStatus}
        viewer={viewer}
      />
    </div>
  );
}
